<template>
  <div class="py-2 bg-workbook-blue">
    <section ref="testimonials"
      class="introslide flex flex-col justify-center min-h-screen bg-workbook-blue w-screen overflow-hidden pb-12 lg:pb-0 pl-0">
      <UContainer class="px-4 lg:px-6">
        <UPageGrid>
          <div class="col-span-4 lg:col-span-7 mt-8 lg:mt-0">
            <h1 class="mb-6 lg:mb-20">
              Happy clients and users
            </h1>
          </div>
        </UPageGrid>
      </UContainer>
      <UContainer class="px-4 xl:px-6 2xl:px-0">
        <div class="flex flex-col lg:flex-row lg:flex-nowrap lg:items-start lg:gap-20 w-full testimonialcarousel">
          <div
            class="w-full lg:w-max grid grid-cols-1 gap-20 md:grid-cols-2 lg:flex lg:flex-row mb-10 lg:mb-0 flex-none">
            <div class="testimonial">
              <Logo7mesh />
              <h2>Tyler Jordan, – CEO 7mesh Industries</h2>
              <p>
                “A lot goes on behind the scenes of launching a new collection and our latest fall 2026 release is no
                exception.
              </p>
              <p>
                We're grateful to have our long term partners Hjärtat always working behind the scenes, whether it's
                photoshoots, studio assets, image editing or creating our best in class digital workbooks.”
              </p>
            </div>

            <div class="testimonial">
              <LogoCiele />
              <h2>Daniel Marrett – Global Director Marketing and Sales</h2>
              <p>
                “Working with the Kudos team to design our digital catalogue was a great experience. They listened to our needs, solved complex challenges with a positive mindset, and elevated both navigation and functionality. Their product insight, project management, and strong brand sense resulted in a catalogue that exceeded expectations and removed the need for constant version updates.”
              </p>

            </div>

            <div class="testimonial">

              <h2>John Zopfi – Commercial Director.</h2>
              <p>
                “Over the past 20 years I’ve worked with Patagonia, Gore, Houdini, 7mesh and many other brands.
               </p>
               <p>
                Having worked with Kudo Sales as a sales tools for several years now, I can confidently say that it has
                revolutionized the way I present products to clients.”
              </p>
            </div>
          </div>
          <div class="quotecarousel w-full lg:w-max lg:pl-20 mt-10 lg:mt-0 flex-none">
            <div
              class="row1 grid grid-cols-1 gap-10 md:grid-cols-2 lg:flex lg:flex-row lg:gap-20 mb-10 lg:mb-12 lg:pl-60">

              <div class="quote">
              <h2>
                “This catalogue is so f***ing rad and we love it.”
              </h2>

              <p>Daniel Marrett – Global Director Marketing and Sales</p>
              
            </div>
              <div class="quote">
                <h2>“The best in the Industry” </h2>
                <p>– Jan Zimmermann, Buyer at Bike-Components.de</p>
              </div>
              <div class="quote">
                <h2>“I love it and I don’t know how I could work without it!” </h2>
                <p>– David Vernay – Ciele distributor in France</p>
              </div>
            </div>
            <div class="row2 grid grid-cols-1 gap-10 md:grid-cols-2 lg:flex lg:flex-row lg:gap-20">
              <div class="quote">
                <h2>“The Golden Standard among workbooks” </h2>
                <p>– Michael Wyser, Swiss Arc’teryx & 7mesh Distributor </p>
              </div>
              <div class="quote">
                <h2>“Beautiful, practical tools that capture and share a brand's magic.”</h2>
                <p>– Tyler Jordan, CEO 7mesh</p>
              </div>

            </div>
          </div>
        </div>
      </UContainer>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'

import { useWindowSize } from '@vueuse/core'
import { loadGsap } from '@/utils/gsap'

const testimonials = ref<HTMLElement | null>(null)
let ctx: gsap.Context | null = null

const { width } = useWindowSize()
const isLgUp = computed(() => width.value >= 1024)

onMounted(async () => {
  if (!process.client || !testimonials.value || !isLgUp.value) return

  const { gsap } = await loadGsap()

  const testimonialcarousel = testimonials.value.querySelector('.testimonialcarousel') as HTMLElement | null
  if (!testimonialcarousel) return

  ctx = gsap.context(() => {
    const tlTestimonials = gsap.timeline({
      scrollTrigger: {
        trigger: testimonials.value,
        pin: true,
        markers: false,
        start: 'top -2%',
        end: 'top -200%',
        scrub: 2
      }
    })

    const getCarouselOffset = () => {
      return Math.max(0, testimonialcarousel.scrollWidth - testimonialcarousel.clientWidth + 40)
    }

    tlTestimonials.fromTo(
      testimonialcarousel,
      { x: 0 },
      {
        x: () => -getCarouselOffset(),
        duration: 8,
        ease: 'none'
      }
    )
  }, testimonials.value || undefined)
})

onUnmounted(() => {
  ctx?.revert()
  ctx = null
})
</script>

<style scoped>
@reference "../../assets/css/main.css";

p {
  @apply text-xl lg:text-2xl;
}

.testimonial {
  @apply mx-0 lg:mx-0 lg:w-100 flex-none border-8 border-black p-6 bg-workbook-white mb-auto;
}

.quote {
  @apply mx-0 lg:mx-0 w-full lg:w-max max-w-none border-8 border-black p-6 bg-workbook-white mb-auto;
}

.testimonial h2,
.quote h2 {
  @apply text-2xl font-normal mt-4 mb-4;
}

.testimonial p,
.quote p {
  @apply text-lg mb-4;
}
</style>
